<template>
  <div class="contactmap">
    <div class="body">
      <div class="left">
        <div class="title">联系我们</div>
        <div class="item" v-for="item in contactmapList" :key="item.id">
          <img :src="item.logo" alt="" />
          <div style="display: flex">
            <div>{{ item.label }}</div>
            <div>
              <div v-for="(it, index) in item.title" :key="index">{{ it }}</div>
            </div>
          </div>
        </div>
        <div class="contact_list">
          <div class="contact_item" v-for="item in contactList" :key="item.id">
            <img :src="item.img" alt="" />
            <div>{{ item.text }}</div>
            <div>{{ item.title }}</div>
          </div>
        </div>
      </div>

      <div class="right">
        <div id="map"></div>
      </div>
    </div>
  </div>
</template>
 
<script>
import { defineComponent, nextTick, onMounted, reactive } from "vue";

import contactmapLogo1 from "../../../assets/contact/contactmapLogo1.png";
// import contactmapLogo2 from "../../../assets/contact/contactmapLogo2.png";
import contactmapLogo3 from "../../../assets/contact/contactmapLogo3.png";
import contactmapLogo4 from "../../../assets/contact/contactmapLogo4.png";

import contactImg1 from "../../../assets/contact/contactImg1.png";
import contactImg2 from "../../../assets/contact/contactImg2.png";

export default defineComponent({
  setup() {
    onMounted(() => {
      nextTick(() => {
        initMap();
      });
    });
    const initMap = () => {
      let Bmap = window.BMap;
      let map = new Bmap.Map("map");
      map.centerAndZoom(
        new Bmap.Point(121.4140350813373, 31.428939331498903),
        32
      );

      var marker = new Bmap.Marker(
        new Bmap.Point(121.4140350813373, 31.428939331498903)
      ); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
      var opts = {
        width: 250, // 信息窗口宽度
        height: 80, // 信息窗口高度
        title: "名称：上海畅月物业管理有限公司", // 信息窗口标题
      };
      var infoWindow = new Bmap.InfoWindow(
        "电话：021-6111-9222<br/>地址：上海市宝山区川巷路88-2",
        opts
      ); // 创建信息窗口对象
      marker.addEventListener("click", function () {
        map.openInfoWindow(
          infoWindow,
          new Bmap.Point(121.4140350813373, 31.428939331498903)
        ); //开启信息窗口
      });
    };
    const state = reactive({
      contactmapList: [
        {
          id: 1,
          title: ["何女士"],
          logo: contactmapLogo1,
          label: "联系人：",
        },
        {
          id: 3,
          title: ["021-6111-9222"],
          logo: contactmapLogo3,
          label: "服务热线：",
        },
        {
          id: 2,
          title: ["181-2107-8988", "132-9612-5222"],
          logo: contactmapLogo3,
          label: "服务电话：",
        },
        {
          id: 4,
          title: ["上海市宝山区川巷路88-2"],
          logo: contactmapLogo4,
          label: "地址：",
        },
      ],
      contactList: [
        {
          id: 1,
          img: contactImg1,
          title: "领取体验账号",
          text: "添加微信",
        },
        {
          id: 2,
          img: contactImg2,
          title: "了解更多",
          text: "关注公众号",
        },
      ],
    });
    return { ...state };
  },
});
</script>

<style scoped>
@media screen and (max-width: 1180px) {
  .contactmap {
    min-width: 1180px;
  }
}
.contactmap {
  background: linear-gradient(180deg, #eff7ff 0%, #fdfeff 100%);
  padding: 60px 0;
  margin-top: 80px;
}
.body {
  width: 1180px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.body .left .title {
  font-size: 24px;
  color: #2a3d50;
}
.body .left .item {
  display: flex;
  align-items: center;
  margin-top: 40px;
}
.body .left .item img {
  width: 28px;
  margin-right: 20px;
}
.body .left .item div {
  font-size: 16px;
  color: #2a3d50;
}
#map {
  width: 800px;
  height: 100%;
}
.contact_list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 40px;
}
.contact_item {
  margin: 0 10px;
  text-align: center;
}
.contact_item img {
  width: 133px;
}
.contact_item div:nth-of-type(1) {
  font-size: 14px;
  color: #3d3d3d;
  margin-top: 6px;
}
.contact_item div:nth-of-type(2) {
  font-size: 16px;
  color: #333333;
  margin-top: 4px;
}
</style>